import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitBranch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M5.75 7a.75.75 0 0 0-1.5 0h1.5Zm-1.5 6a.75.75 0 0 0 1.5 0h-1.5Zm11.5-4a.75.75 0 0 0-1.5 0h1.5Zm-8.5-5H6.5A1.5 1.5 0 0 1 5 5.5V7a3 3 0 0 0 3-3h-.75ZM5 6.25V5.5A1.5 1.5 0 0 1 3.5 4H2a3 3 0 0 0 3 3v-.75ZM2.75 4h.75A1.5 1.5 0 0 1 5 2.5V1a3 3 0 0 0-3 3h.75ZM5 1.75v.75A1.5 1.5 0 0 1 6.5 4H8a3 3 0 0 0-3-3v.75ZM17.25 6h-.75A1.5 1.5 0 0 1 15 7.5V9a3 3 0 0 0 3-3h-.75ZM15 8.25V7.5A1.5 1.5 0 0 1 13.5 6H12a3 3 0 0 0 3 3v-.75ZM12.75 6h.75A1.5 1.5 0 0 1 15 4.5V3a3 3 0 0 0-3 3h.75ZM15 3.75v.75A1.5 1.5 0 0 1 16.5 6H18a3 3 0 0 0-3-3v.75ZM7.25 16H6.5A1.5 1.5 0 0 1 5 17.5V19a3 3 0 0 0 3-3h-.75ZM5 18.25v-.75A1.5 1.5 0 0 1 3.5 16H2a3 3 0 0 0 3 3v-.75ZM2.75 16h.75A1.5 1.5 0 0 1 5 14.5V13a3 3 0 0 0-3 3h.75ZM5 13.75v.75A1.5 1.5 0 0 1 6.5 16H8a3 3 0 0 0-3-3v.75ZM5 7h-.75v6h1.5V7H5Zm10 2h-.75c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0 0 15.75 9H15Zm-8 2v-.75A2.75 2.75 0 0 0 4.25 13h1.5c0-.69.56-1.25 1.25-1.25V11Zm6 0v-.75H7v1.5h6V11Z"
	})]
});
const ForwardRef = forwardRef(SvgGitBranch);
export { ForwardRef as ReactComponent };
